import React, { useCallback, useEffect, useRef, useState } from "react";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import {
  Box,
  Button,
  TextField,
  Typography,
  FormControl,
  Autocomplete,
  CircularProgress,
  InputAdornment,
  Card,
  CardContent,
  Grid,
  Divider,
  Select,
  MenuItem,
  InputLabel,
  Chip,
} from "@mui/material";
import {
  Search,
  Person as PersonIcon,
  Description as DescriptionIcon,
  AccessTime as AccessTimeIcon,
  Category as CategoryIcon,
  Phone as PhoneIcon,
  CheckCircle as CheckCircleIcon,
  Business as BusinessIcon,
} from "@mui/icons-material";
import { Switch, FormControlLabel } from "@mui/material";
import { FaX, FaCheck } from "react-icons/fa6";
import { useAuth } from "../login/AuthContext";
import axios from "axios";
import config from "../../config/config";
import { toast } from "react-toastify";

const SupportForm = ({ open, onClose, supportId, initialMusteriId }) => {
  const { token, userData } = useAuth();
  const [formValues, setFormValues] = useState({
    MusteriId: initialMusteriId || "",
    GorusulenKisi: "",
    Telefon: "",
    DestekTuru: "",
    Modul: "",
    BaslangicSaati: "",
    BitisSaati: "",
    DestekAciklamasi: "",
    Durum: "Destek Verildi",
  });
  const [customers, setCustomers] = useState([]);
  const [isCustomerLoading, setIsCustomerLoading] = useState(false);
  const [customerSearchMessage, setCustomerSearchMessage] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isNonPozitifOfis, setIsNonPozitifOfis] = useState(false);
  const debouncedCustomerSearchRef = useRef(null);

  const destekTurleri = ["Uzaktan destek", "Satış", "Bayi", "Eğitim", "Diğer"];
  const moduller = [
    "Genel",
    "Grafik Paneli",
    "Ayarlar",
    "Stok Yönetimi",
    "Cari Yönetimi",
    "Kasa Yönetimi",
    "Banka Yönetimi",
    "Teklif",
    "Sipariş",
    "Sevkiyat",
    "İrsaliye",
    "E-İrsaliye",
    "Fatura",
    "E-Fatura",
    "Stok Fişleri",
    "Depo Fişleri",
    "Sayım",
    "Cari Bordroları",
    "Banka Bordroları",
    "Dış Erişim",
    "İleti Yönetimi",
    "Hızlı Satış",
    "Rapor(Eski)",
    "Rapor Merkezi",
    "Sepet",
    "Ajanda",
    "Fiyat Değişim",
    "Hızlı Üretim",
    "Sevk Kontrol",
    "Online Banka",
    "Diğer",
  ];
  const durumlar = [
    "Çağrı yanıtlanmadı",
    "Çağrı cevaplandı",
    "Destek Verildi",
    "Ar-Ge'ye iletildi",
    "Destek verilemedi",
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case "Destek Verildi":
        return "#10B981";
      case "Çağrı cevaplandı":
        return "#14B8A6";
      case "Çağrı yanıtlanmadı":
        return "#F59E0B";
      case "Ar-Ge'ye iletildi":
        return "#3B82F6";
      case "Destek verilemedi":
        return "#EF4444";
      default:
        return "#6B7280";
    }
  };

  // Müşteri arama fonksiyonu
  const searchCustomers = useCallback(
    async (query) => {
      if (!query || query.length < 3) {
        setCustomers([]);
        setIsCustomerLoading(false);
        setCustomerSearchMessage("En az 3 karakter giriniz");
        return;
      }
      try {
        setIsCustomerLoading(true);
        setCustomerSearchMessage("");
        const res = await axios.get(`${config.baseURL}/musteriler/search`, {
          headers: { Authorization: `Bearer ${token}` },
          params: { query, searchFields: ["Unvan", "Yetkili", "VergiNo"] },
        });
        const list = res?.data?.data || res?.data || [];
        setCustomers(Array.isArray(list) ? list : []);
      } catch (err) {
        setCustomers([]);
        setCustomerSearchMessage("Arama sırasında hata oluştu");
      } finally {
        setIsCustomerLoading(false);
      }
    },
    [token]
  );

  // Destek kaydı getir (düzenleme için)
  useEffect(() => {
    const fetchSupport = async () => {
      if (supportId && open) {
        try {
          setLoading(true);
          const response = await axios.get(
            `${config.baseURL}/destek/${supportId}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
          const support = response.data.data;

          setFormValues({
            MusteriId: support.MusteriId || "",
            GorusulenKisi: support.GorusulenKisi || "",
            Telefon: support.Telefon || "",
            DestekTuru: support.DestekTuru || "",
            Modul: support.Modul || "",
            BaslangicSaati: support.BaslangicSaati || "",
            BitisSaati: support.BitisSaati || "",
            DestekAciklamasi: support.DestekAciklamasi || "",
            Durum: support.Durum || "Destek Verildi",
          });

          // Müşteri bilgisini yükle
          if (support.MusteriId && support.Musteri) {
            setSelectedCustomer(support.Musteri);
          } else if (support.MusteriId) {
            try {
              const custRes = await axios.get(
                `${config.baseURL}/musteriler/${support.MusteriId}`,
                {
                  headers: { Authorization: `Bearer ${token}` },
                }
              );
              setSelectedCustomer(custRes.data || custRes.data?.data || null);
            } catch (err) {
              console.error("Müşteri bilgisi yüklenemedi:", err);
            }
          }

          // Initial müşteri ID varsa onu da yükle
          if (initialMusteriId && !support.MusteriId) {
            try {
              const custRes = await axios.get(
                `${config.baseURL}/musteriler/${initialMusteriId}`,
                {
                  headers: { Authorization: `Bearer ${token}` },
                }
              );
              const customer = custRes.data || custRes.data?.data;
              if (customer) {
                setSelectedCustomer(customer);
                setFormValues((prev) => ({
                  ...prev,
                  MusteriId: initialMusteriId,
                }));
              }
            } catch (err) {
              console.error("Müşteri bilgisi yüklenemedi:", err);
            }
          }
        } catch (error) {
          console.error("Destek kaydı yüklenemedi:", error);
          toast.error("Destek kaydı yüklenemedi");
        } finally {
          setLoading(false);
        }
      } else if (!supportId && open && initialMusteriId) {
        // Yeni kayıt ve initial müşteri ID var
        try {
          const custRes = await axios.get(
            `${config.baseURL}/musteriler/${initialMusteriId}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
          const customer = custRes.data || custRes.data?.data;
          if (customer) {
            setSelectedCustomer(customer);
            setFormValues((prev) => ({
              ...prev,
              MusteriId: initialMusteriId,
            }));
          }
        } catch (err) {
          console.error("Müşteri bilgisi yüklenemedi:", err);
        }
      } else if (!supportId && open) {
        // Yeni kayıt, formu sıfırla
        setFormValues({
          MusteriId: "",
          GorusulenKisi: "",
          Telefon: "",
          DestekTuru: "",
          Modul: "",
          BaslangicSaati: "",
          BitisSaati: "",
          DestekAciklamasi: "",
          Durum: "Destek Verildi",
          MusteriAdi: "", // Pozitif Ofis dışı müşteriler için
        });
        setSelectedCustomer(null);
        setIsNonPozitifOfis(false);
      }
    };

    fetchSupport();
  }, [supportId, open, token, initialMusteriId]);

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    // Validasyon - Zorunlu alanlar (yeni kayıtta müşteri zorunlu; Caller ID düzenlemede seçim opsiyonel)
    if (!supportId && !isNonPozitifOfis && !formValues.MusteriId) {
      toast.error("Müşteri seçimi zorunludur");
      return;
    }

    if (isNonPozitifOfis && (!formValues.MusteriAdi || formValues.MusteriAdi.trim() === "")) {
      toast.error("Müşteri adı zorunludur");
      return;
    }

    if (!formValues.DestekTuru || formValues.DestekTuru.trim() === "") {
      toast.error("Destek türü zorunludur");
      return;
    }

    if (!formValues.Modul || formValues.Modul.trim() === "") {
      toast.error("Modül seçimi zorunludur");
      return;
    }

    if (!formValues.BaslangicSaati || formValues.BaslangicSaati.trim() === "") {
      toast.error("Başlangıç saati zorunludur");
      return;
    }

    if (!formValues.BitisSaati || formValues.BitisSaati.trim() === "") {
      toast.error("Bitiş saati zorunludur");
      return;
    }

    if (!formValues.DestekAciklamasi || formValues.DestekAciklamasi.trim().length < 1) {
      toast.error("Destek açıklaması zorunludur (en az 1 karakter)");
      return;
    }

    try {
      setLoading(true);
      
      // Pozitif Ofis dışı müşteriler için JSON dosyasına kaydet
      if (isNonPozitifOfis && !supportId) {
        const url = `${config.baseURL}/destek/non-pozitif-ofis`;
        const payload = {
          ...formValues,
          KullaniciId: userData?.Id || null,
          KullaniciAdi: userData?.KullaniciAdi || null,
          AdSoyad: userData?.Adi && userData?.Soyadi 
            ? `${userData.Adi} ${userData.Soyadi}` 
            : userData?.KullaniciAdi || null,
          OlusturmaTarihi: new Date().toISOString().split('T')[0],
        };
        
        await axios.post(url, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });

        toast.success("Destek kaydı oluşturuldu (Pozitif Ofis dışı)");
        onClose();
        return;
      }

      // Normal Pozitif Ofis müşterileri için veritabanına kaydet
      const url = supportId
        ? `${config.baseURL}/destek/${supportId}`
        : `${config.baseURL}/destek`;
      const method = supportId ? "put" : "post";

      console.log("🚀 Destek kaydı gönderiliyor:", { url, method, formValues });
      
      await axios[method](url, formValues, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success(
        supportId
          ? "Destek kaydı güncellendi"
          : "Destek kaydı oluşturuldu"
      );
      onClose();
    } catch (error) {
      const data = error.response?.data;
      console.error("Destek kaydı kaydedilemedi:", error);
      if (data) console.error("Sunucu yanıtı (500 sebebi):", data);
      const msg = data?.message || "Destek kaydı kaydedilirken hata oluştu";
      const detail = data?.detail;
      toast.error(detail ? `${msg} (${detail})` : msg);
    } finally {
      setLoading(false);
    }
  };

  const SectionHeader = ({ icon: Icon, title }) => (
    <Box display="flex" alignItems="center" gap={1.5} mb={1.5}>
      <Icon
        sx={{
          color: "rgba(0,0,0,0.54)",
          fontSize: "20px",
        }}
      />
      <Typography
        variant="subtitle1"
        fontWeight={700}
        color="text.secondary"
        sx={{
          letterSpacing: "0.02em",
          textTransform: "uppercase",
          fontSize: "0.75rem",
        }}
      >
        {title}
      </Typography>
    </Box>
  );

  return (
    <Drawer
      open={open}
      onClose={onClose}
      direction="right"
      className="custom-drawer"
      duration={300}
      size={600}
      zIndex={600}
    >
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          bgcolor: "#F9FAFB",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            p: 2,
            borderBottom: 1,
            borderColor: "divider",
            bgcolor: "white",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" fontWeight={600}>
            {supportId ? "Destek Kaydı Düzenle" : "Yeni Destek Kaydı"}
          </Typography>
          <Button
            onClick={onClose}
            sx={{ minWidth: "auto", p: 1 }}
            color="inherit"
          >
            <FaX size={20} />
          </Button>
        </Box>

        {/* Content */}
        <Box sx={{ flex: 1, overflowY: "auto", p: 2 }}>
          {loading && !formValues.MusteriId && !isNonPozitifOfis ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="200px"
            >
              <CircularProgress />
            </Box>
          ) : (
            <>
              {/* Toggle Butonu - Sadece yeni kayıt için */}
              {!supportId && (
                <Card elevation={0} sx={{ mb: 1.5, bgcolor: "#F3F4F6" }}>
                  <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={isNonPozitifOfis}
                          onChange={(e) => {
                            setIsNonPozitifOfis(e.target.checked);
                            if (e.target.checked) {
                              // Toggle aktif olduğunda müşteri seçimini temizle
                              setSelectedCustomer(null);
                              setFormValues((prev) => ({
                                ...prev,
                                MusteriId: "",
                                MusteriAdi: "",
                              }));
                            } else {
                              // Toggle pasif olduğunda manuel müşteri adını temizle
                              setFormValues((prev) => ({
                                ...prev,
                                MusteriAdi: "",
                              }));
                            }
                          }}
                          color="primary"
                        />
                      }
                      label={
                        <Box display="flex" alignItems="center" gap={1}>
                          <BusinessIcon fontSize="small" />
                          <Typography variant="body1" fontWeight={500}>
                            Pozitif Ofis Dışı Müşteri
                          </Typography>
                        </Box>
                      }
                    />
                    <Typography variant="caption" color="textSecondary" sx={{ ml: 4, display: "block", mt: 0.5 }}>
                      {isNonPozitifOfis
                        ? "Pozitif Ofis müşterisi olmayan kişilerin destek bilgilerini girebilirsiniz"
                        : "Pozitif Ofis müşterileri için destek kaydı oluşturulacak"}
                    </Typography>
                  </CardContent>
                </Card>
              )}

              <Card elevation={0} sx={{ mb: 1.5 }}>
                <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
                  <SectionHeader icon={PersonIcon} title="Müşteri Bilgileri" />
                  <Divider sx={{ mb: 2, mt: 0.5 }} />
                  {isNonPozitifOfis && !supportId ? (
                    <TextField
                      label="Müşteri Adı"
                      name="MusteriAdi"
                      value={formValues.MusteriAdi || ""}
                      onChange={handleFormChange}
                      fullWidth
                      required
                      placeholder="Pozitif Ofis dışı müşteri adını giriniz"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <BusinessIcon color="action" fontSize="small" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  ) : (
                    <FormControl fullWidth>
                      <Autocomplete
                        value={selectedCustomer}
                        required={!supportId}
                        onChange={(event, newValue) => {
                          setSelectedCustomer(newValue);
                          setFormValues((prev) => ({
                            ...prev,
                            MusteriId: newValue?.Id || "",
                          }));
                        }}
                        onInputChange={(event, newValue) => {
                          if (debouncedCustomerSearchRef.current) {
                            clearTimeout(debouncedCustomerSearchRef.current);
                          }
                          debouncedCustomerSearchRef.current = setTimeout(
                            () => searchCustomers(newValue),
                            300
                          );
                        }}
                        options={customers}
                        getOptionLabel={(option) =>
                          option && (option.Unvan != null || option.Yetkili != null)
                            ? `${option.Unvan || ""}${option.Yetkili ? ` - ${option.Yetkili}` : ""}`
                            : ""
                        }
                        isOptionEqualToValue={(option, value) =>
                          option && value && option.Id === value.Id
                        }
                        filterOptions={(x) => x}
                        loading={isCustomerLoading}
                        noOptionsText={
                          customerSearchMessage || "Sonuç bulunamadı"
                        }
                        disabled={!!(supportId && formValues.MusteriId)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Müşteri Seç"
                            required={!supportId}
                            disabled={!!(supportId && formValues.MusteriId)}
                            helperText={
                              supportId && !formValues.MusteriId
                                ? "Caller ID kaydı — müşteri seçebilirsiniz"
                                : supportId && formValues.MusteriId
                                ? "Müşteri değiştirilemez"
                                : customerSearchMessage
                            }
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: (
                                <>
                                  <InputAdornment position="start">
                                    <Search />
                                  </InputAdornment>
                                  {params.InputProps.startAdornment}
                                </>
                              ),
                              endAdornment: (
                                <>
                                  {isCustomerLoading ? (
                                    <CircularProgress
                                      color="inherit"
                                      size={20}
                                    />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                      />
                    </FormControl>
                  )}
                </CardContent>
              </Card>

              <Card elevation={0} sx={{ mb: 1.5 }}>
                <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
                  <SectionHeader icon={PersonIcon} title="Görüşülen Kişi" />
                  <Divider sx={{ mb: 2, mt: 0.5 }} />
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Görüşülen Kişi"
                        name="GorusulenKisi"
                        value={formValues.GorusulenKisi}
                        onChange={handleFormChange}
                        fullWidth
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <PersonIcon color="action" fontSize="small" />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Telefon"
                        name="Telefon"
                        value={formValues.Telefon}
                        onChange={handleFormChange}
                        fullWidth
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <PhoneIcon color="action" fontSize="small" />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>

              <Card elevation={0} sx={{ mb: 1.5 }}>
                <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
                  <SectionHeader icon={AccessTimeIcon} title="Destek Saatleri" />
                  <Divider sx={{ mb: 2, mt: 0.5 }} />
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Başlangıç Saati"
                        name="BaslangicSaati"
                        type="time"
                        value={formValues.BaslangicSaati}
                        onChange={handleFormChange}
                        fullWidth
                        required
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <AccessTimeIcon color="action" fontSize="small" />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Bitiş Saati"
                        name="BitisSaati"
                        type="time"
                        value={formValues.BitisSaati}
                        onChange={handleFormChange}
                        fullWidth
                        required
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <AccessTimeIcon color="action" fontSize="small" />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>

              <Card elevation={0} sx={{ mb: 1.5 }}>
                <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
                  <SectionHeader icon={CategoryIcon} title="Destek Türü ve Modül" />
                  <Divider sx={{ mb: 2, mt: 0.5 }} />
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth required>
                        <InputLabel>Destek Türü</InputLabel>
                        <Select
                          name="DestekTuru"
                          value={formValues.DestekTuru}
                          onChange={handleFormChange}
                          label="Destek Türü"
                          required
                        >
                          {destekTurleri.map((tur) => (
                            <MenuItem key={tur} value={tur}>
                              {tur}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth required>
                        <InputLabel>Modül</InputLabel>
                        <Select
                          name="Modul"
                          value={formValues.Modul}
                          onChange={handleFormChange}
                          label="Modül"
                          required
                        >
                          {moduller.map((modul) => (
                            <MenuItem key={modul} value={modul}>
                              {modul}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>

              <Card elevation={0} sx={{ mb: 1.5 }}>
                <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
                  <SectionHeader icon={CheckCircleIcon} title="Durum" />
                  <Divider sx={{ mb: 2, mt: 0.5 }} />
                  <FormControl fullWidth>
                    <InputLabel>Durum</InputLabel>
                    <Select
                      name="Durum"
                      value={formValues.Durum}
                      onChange={handleFormChange}
                      label="Durum"
                      renderValue={(selected) => (
                        <Chip
                          label={selected}
                          size="small"
                          sx={{
                            bgcolor: getStatusColor(selected),
                            color: "white",
                            fontWeight: 500,
                          }}
                        />
                      )}
                    >
                      {durumlar.map((durum) => (
                        <MenuItem key={durum} value={durum}>
                          {durum}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </CardContent>
              </Card>

              <Card elevation={0} sx={{ mb: 1.5 }}>
                <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
                  <SectionHeader
                    icon={DescriptionIcon}
                    title="Destek Açıklaması"
                  />
                  <Divider sx={{ mb: 2, mt: 0.5 }} />
                  <TextField
                    label="Destek Açıklaması"
                    name="DestekAciklamasi"
                    value={formValues.DestekAciklamasi}
                    onChange={handleFormChange}
                    fullWidth
                    required
                    multiline
                    rows={6}
                    placeholder="Destek içeriğini detaylı olarak yazın... (En az 1 karakter)"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment
                          position="start"
                          sx={{ alignSelf: "flex-start", mt: 1 }}
                        >
                          <DescriptionIcon color="action" fontSize="small" />
                        </InputAdornment>
                      ),
                    }}
                  />
                </CardContent>
              </Card>
            </>
          )}
        </Box>

        {/* Footer */}
        <Box
          sx={{
            p: 2,
            borderTop: 1,
            borderColor: "divider",
            bgcolor: "white",
            display: "flex",
            justifyContent: "flex-end",
            gap: 2,
          }}
        >
          <Button onClick={onClose} variant="outlined" disabled={loading}>
            İptal
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            startIcon={loading ? <CircularProgress size={20} /> : <FaCheck />}
            disabled={loading}
            sx={{ bgcolor: "#00A7B5", "&:hover": { bgcolor: "#008B98" } }}
          >
            {supportId ? "Güncelle" : "Kaydet"}
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};

export default SupportForm;





